//
// Generated class DBDocumentLineClassification
//

/// <reference path="DBDocumentLineClassification_ManagedObject.ts" />

class DBDocumentLineClassification extends DBDocumentLineClassification_ManagedObject
{

}
